import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Flex, SxProps, Text } from '@modusign/design-system';
import { ReactNode } from 'react';

interface InfoCalloutProps extends SxProps {
  children: ReactNode;
}

export default function InfoCallout({ children, sx }: InfoCalloutProps) {
  return (
    <Flex
      alignItems="center"
      as="section"
      bg="notificationBackgroundPrimaryBase"
      border="1px solid"
      borderColor="boxBorderPrimaryBase"
      borderRadius="3px"
      color="textNeutralSlightlyLight"
      px={5}
      py={4}
      sx={sx}
    >
      <Text color="darkGray200" fontSize="12px" mr={2}>
        <FontAwesomeIcon icon={faInfoCircle} />
      </Text>
      <Text color="textNeutralSlightlyLight" fontSize="sm">
        {children}
      </Text>
    </Flex>
  );
}
